// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"c063d542","283":"26d5a3cd","355":"7f6b5cc9","453":"a8893d93"}[chunkId] + ".chunk.js";
};